'use client';

import { Flex, HStack } from '@react/chakra';
import { useSuspenseQuery } from '@react/utils/queryHooks';

import type { JSX } from 'react';

import { Topic } from '../Topic';
import { useTopicQuery } from '../hooks';
import { topicsOptions } from '../queries';

export function TopicList(): JSX.Element {
  const { data } = useSuspenseQuery(topicsOptions());
  const [topicQuery] = useTopicQuery();

  const groupedTopicQuery = (topicQuery || []).reduce<Record<string, string>>(
    (result, value) => {
      result[value] = value;

      return result;
    },
    {},
  );

  return (
    <HStack gap={2} flexWrap='wrap'>
      {data.map((topic) => {
        const selected = !!groupedTopicQuery[topic.slug];

        return (
          <Flex
            pos='relative'
            key={topic.slug}
            transitionDuration='.15s'
            transitionTimingFunction='cubic-bezier(.4, 0, .2,1)'
            transitionProperty='color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter'
          >
            <Topic data={topic} selected={selected} />
          </Flex>
        );
      })}
    </HStack>
  );
}
